import React from 'react';

const ModalInteractiveText = ({ showModal, onClose, onSubmit }) => {
	const [inputText, setInputText] = React.useState('');

	const handleSubmit = () => {
		if (inputText) {
			onSubmit(inputText);
			setInputText(''); // Clear the input after submitting
			onClose(); // Close the modal
		}
	};

	if (!showModal) return null;

	return (
		<div className="modal-overlay" style={modalOverlayStyle}>
			<div
				className={
					showModal
						? 'size-full fixed top-1/3 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none'
						: 'hidden size-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none'
				}
				role="dialog"
				tabIndex="-1"
			>
				<div className="mt-0 ease-out transition-all sm:max-w-lg sm:w-full m-3 sm:mx-auto">
					<div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
						<div className="flex justify-between items-center py-3 px-4 border-b dark:border-neutral-700">
							<h3 className="font-bold text-gray-800 dark:text-white">Enter Text</h3>
							<button
								type="button"
								className="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
								ariaLabel="Close"
								onClick={onClose}
							>
								<span className="sr-only">Close</span>
								<svg
									className="shrink-0 size-4"
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								>
									<path d="M18 6 6 18"></path>
									<path d="m6 6 12 12"></path>
								</svg>
							</button>
						</div>
						<div className="p-4 overflow-y-auto">
							<label for={'labelText'}>Text:</label>
							<input
								id="labelText"
								className={
									'py-3 px-4 block w-full border border-gray-200 shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-100 dark:border-slate-200 dark:text-black dark:focus:ring-gray-600'
								}
								type="text"
								value={inputText}
								onChange={(e) => setInputText(e.target.value)}
								style={inputStyle}
							/>
						</div>
						<div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-neutral-700">
							<button
								type="button"
								onClick={onClose}
								className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-800 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-700 dark:focus:bg-neutral-700"
								data-hs-overlay="#hs-static-backdrop-modal"
							>
								Close
							</button>
							<button
								type="button"
								onClick={handleSubmit}
								className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
							>
								Add Text
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

// Modal styles
const modalOverlayStyle = {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	zIndex: 9999,
	backgroundColor: 'rgba(0, 0, 0, 0.5)',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

const modalContentStyle = {
	backgroundColor: 'white',
	padding: '20px',
	borderRadius: '5px',
	boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
};

const inputStyle = {
	marginBottom: '10px',
	width: '100%',
};

export default ModalInteractiveText;
